import Container from "@/components/common/Container";
import useOnScreen from "hooks/useOnScreen";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import Title from "./common/Title";

const ResponsiveUI = () => {
  const ResponsiveUIImage = useRef(null);
  const isVisible = useOnScreen(ResponsiveUIImage);
  const [imageVisible, setImageVisible] = useState(isVisible);
  useEffect(() => {
    if (isVisible) {
      setImageVisible(isVisible);
    }
  }, [isVisible]);
  return (
    <Container className="bg-black-pearl overflow-hidden">
      <Title
        className="pb-20 xl:pb-24 pl-0 md:pl-16 xl:pl-24 w-full md:w-4/5 xl:w-3/4"
        customClass="pb-6 xl:pb-10"
        Description="We have made efforts to ensure a user-friendly experience on different devices. Additionally, we have implemented a responsive version of the website, adapting the design to various screen sizes and orientations. This allows us to address the challenges and solutions in cryptocurrency web design and emphasizes the importance of responsiveness for a diverse user base."
        SubTitle="Responsive UI"
      />
      <Container large>
        <div
          ref={ResponsiveUIImage}
          className={`fs-0 text-center pb-20 xl:pb-36 ${
            imageVisible ? "animate-slide-up" : ""
          }`}
        >
          <Image
            alt="uIdesign2"
            height={962}
            src={"/assets/case-study/mobifinx/responsive-ui.webp"}
            width={1322}
          />
        </div>
      </Container>
    </Container>
  );
};

export default ResponsiveUI;
